<div #suggestionsList class="container">
	@for (card of _data; track card; let isLast = $last; let index = $index) {
		<div
			class="container__card-wrapper"
			[class]="{
				'container__card-wrapper--last': isLast,
				'container__card-wrapper--selected': card.isSelected
			}"
			(dblclick)="onOptionDoubleClicked(index)"
		>
			<div class="container__content-wrapper">
				<div class="container__info-wrapper">
					<div class="container__info">
						<div class="container__icon-wrapper">
							@if (!card.menuOptions) {
								<mat-icon
									class="container__trash-icon"
									data-testid="suggestion-card-trash"
									svgIcon="trash"
									[matTooltip]="'MODALS.NEW_REPORT_MODAL.SUGGESTIONS.MENU_OPTIONS.DELETE' | translate"
									(click)="actionFromIcon(suggestionMenuOption.Delete, index)"
								>
								</mat-icon>
							}
							@if (card.menuOptions && !card.isMenuHidden) {
								<mat-icon
									class="container__more-icon"
									data-testid="card-menu-icon"
									[matMenuTriggerFor]="menu"
									[svgIcon]="'three_dots'"
								>
								</mat-icon>
							}
						</div>
						<mat-menu #menu="matMenu">
							<lawyal-front-end-new-dropdown
								class="ag-grid__actions__menu"
								data-testid="suggestion-card-menu-dropdown"
								(selectionChange)="actionFromIcon($event, index)"
								[options]="card.menuOptions"
							>
							</lawyal-front-end-new-dropdown>
						</mat-menu>
						<span
							class="container__title"
							[class.container__title--bold]="config()?.isTitleBold"
							[matTooltip]="card.title"
							[matTooltipClass]="tooltipClass"
							>{{ card.title }}
						</span>
					</div>
					<div class="container__subtitle-wrapper">
						<div class="container__total-time-wrapper">
							<span class="container__total-time">{{ card.totalTime }}</span>
							<span class="container__total-time-prefix">{{ card.totalTimePrefix | translate }}</span>
						</div>
						<div class="container__subtitle-text-wrapper">
							<span
								class="container__subtitle"
								[class.container__subtitle--bold]="config().isSubTitleBold"
								[matTooltip]="card.subtitle"
								[matTooltipClass]="tooltipClass"
								>{{ card.subtitle }}
							</span>
							<span class="container__subtitle-prefix">{{ card.subtitlePrefix | translate }}</span>
						</div>
					</div>
				</div>
				@if (config().withIcon) {
					<div class="container__platform-icon-wrapper">
						<mat-icon
							class="container__platform-icon"
							[svgIcon]="card.icon.name"
							[matTooltip]="card.icon.tooltip"
							[matTooltipClass]="tooltipClass"
						></mat-icon>
					</div>
				}
			</div>
			<div
				class="container__side-label-wrapper"
				[class]="{
					'container__side-label-wrapper--morning': card.sideLabelBgColor === timeOfDayColor.LightestBlue,
					'container__side-label-wrapper--midday': card.sideLabelBgColor === timeOfDayColor.LightBlue,
					'container__side-label-wrapper--afternoon': card.sideLabelBgColor === timeOfDayColor.Blue,
					'container__side-label-wrapper--evening': card.sideLabelBgColor === timeOfDayColor.DarkBlue,
					'container__side-label-wrapper--night': card.sideLabelBgColor === timeOfDayColor.DarkestBlue,
					'container__side-label-wrapper--no-time': card.sideLabelBgColor === timeOfDayColor.NoTime
				}"
			>
				<span class="container__side-label" [matTooltip]="card.sideLabel" [style.direction]="sideLabelDirection">{{
					card.sideLabel
				}}</span>
			</div>
		</div>
	}
</div>
